import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { Person as PersonIcon } from '@mui/icons-material';

export default function CustomerSelectList({ results, selected, onSelect, anchorEl }) {
  if (!results || results.length === 0 || !anchorEl) return null;

  return (
    <Popper
      open
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{ zIndex: 1500, width: anchorEl.offsetWidth }}
    >
      <Paper
        elevation={4}
        sx={{
          maxHeight: 300,
          overflow: 'auto',
          borderRadius: '0 0 8px 8px',
          border: '1px solid',
          borderColor: 'divider',
          borderTop: 'none',
        }}
      >
        <List sx={{ p: 0 }}>
          {results.map((item, index) => (
            <ListItem
              key={index}
              button
              onClick={() => onSelect?.(item, index)}
              sx={{
                px: 2, py: 1.5,
                bgcolor: selected === index ? '#f0f8ff' : 'background.paper',
                borderLeft: selected === index ? '4px solid' : 'none',
                borderLeftColor: 'primary.main',
                '&:hover': { bgcolor: 'grey.50' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <PersonIcon
                  sx={{
                    fontSize: 20,
                    color: item.label === 'Make New Customer' ? 'primary.main' : 'text.secondary',
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    sx={{
                      color: item.label === 'Make New Customer' ? 'primary.main' : 'text.primary',
                      fontWeight: item.label === 'Make New Customer' ? 600 : 400,
                      fontSize: 14,
                    }}
                    dangerouslySetInnerHTML={{ __html: item.label }}
                  />
                }
                secondary={
                  item.first_name && (item.address1 || item.city) ? (
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 12 }}>
                      {[item.address1, item.city, item.state, item.zip].filter(Boolean).join(', ')}
                    </Typography>
                  ) : null
                }
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Popper>
  );
}
